import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const BgGradientBlue = ({children}) => {

    return (
        <div styleName={"styles.bgGradLightBlue"}>
            {children}
        </div>
    );
};
BgGradientBlue.propTypes = {
    children: PropTypes.any
};
export default BgGradientBlue;

